import React, { useMemo } from "react";
import { usePagos } from "../state/PagosContext";

function money(n) {
  return `$${Number(n).toLocaleString("es-MX", { maximumFractionDigits: 0 })}`;
}
function suma(arr, f = (x) => x) {
  return arr.reduce((a, b) => a + Number(f(b)), 0);
}

export default function Dashboard({ mes, anio }) {
  const hoy = new Date();
  const m0 = typeof mes === "number" ? mes : hoy.getMonth();
  const y = typeof anio === "number" ? anio : hoy.getFullYear();

  const { pagos, getPendienteMonto } = usePagos();

  const datosMes = useMemo(() => {
    const arr = [];
    for (const p of pagos) {
      const f = new Date(p.fechaAjustada || p.fecha);
      if (f.getFullYear() === y && f.getMonth() === m0) {
        const pen = getPendienteMonto(p);
        if (pen > 0) arr.push({ ...p, pendiente: pen, dia: f.getDate() });
      }
    }
    return arr.sort((a, b) => a.dia - b.dia);
  }, [pagos, m0, y, getPendienteMonto]);

  const totalMes = suma(datosMes, (x) => x.pendiente);
  const totalWorth = suma(datosMes.filter(p => p.responsable === "Worth"), (x) => x.pendiente);
  const totalJPGM = suma(datosMes.filter(p => p.responsable === "JPGM"), (x) => x.pendiente);
  const total115 = suma(datosMes.filter(p => p.dia <= 15), (x) => x.pendiente);
  const total1631 = suma(datosMes.filter(p => p.dia > 15), (x) => x.pendiente);

  const labelMes = new Date(y, m0, 1).toLocaleString("es-MX", { month: "long", year: "numeric" });

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-worthblue font-bold text-xl">Resumen del mes (pendiente)</h3>
        <span className="text-sm text-gray-500">{labelMes}</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        <div className="bg-white rounded-xl shadow p-4 border-t-4 border-worthgold">
          <div className="text-sm text-gray-500">Total programado</div>
          <div className="text-2xl font-extrabold text-worthblue">{money(totalMes)}</div>
        </div>

        <div className="bg-white rounded-xl shadow p-4">
          <div className="text-sm text-gray-500">Worth</div>
          <div className="text-xl font-bold text-worthblue">{money(totalWorth)}</div>
        </div>

        <div className="bg-white rounded-xl shadow p-4">
          <div className="text-sm text-gray-500">JPGM</div>
          <div className="text-xl font-bold text-green-700">{money(totalJPGM)}</div>
        </div>

        <div className="bg-white rounded-xl shadow p-4">
          <div className="text-sm text-gray-500">Pagos pendientes (items)</div>
          <div className="text-xl font-bold text-gray-800">{datosMes.length}</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
        <div className="bg-white rounded-xl shadow p-4">
          <div className="text-sm text-gray-500">1–15</div>
          <div className="text-xl font-bold text-worthblue">{money(total115)}</div>
        </div>
        <div className="bg-white rounded-xl shadow p-4">
          <div className="text-sm text-gray-500">16–31</div>
          <div className="text-xl font-bold text-worthblue">{money(total1631)}</div>
        </div>
        <div className="bg-white rounded-xl shadow p-4">
          <div className="text-sm text-gray-500">Verificación</div>
          <div className="text-xl font-bold text-gray-800">
            {money(total115 + total1631)}
          </div>
          <div className="text-xs text-gray-500">Debe coincidir con “Total programado”.</div>
        </div>
      </div>
    </div>
  );
}
